// removed by extract-text-webpack-plugin
module.exports = {"colour-picker":"style__colour-picker___1E8rQ","browser-container":"style__browser-container___1MGMs","browse-button":"style__browse-button___6Et2Q","browse-file-name":"style__browse-file-name___3JNyQ","form-input-container":"style__form-input-container___2Zhlq"};


//////////////////
// WEBPACK FOOTER
// ./components/ModuleForm/style.scss
// module id = 1328
// module chunks = 0